import { t } from "../lib/i18n";
import PublicNavbar from './PublicNavbar';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <PublicNavbar />
      <div className="container mx-auto py-10 px-4 max-w-4xl">
      <Link to="/" className="inline-block mt-4 mb-8 bg-indigo-700 text-white font-bold px-6 py-3 rounded-lg shadow-md hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 no-underline">{t("termsOfService.k1")}</Link>
      <h1 className="text-center text-2xl font-bold mb-4">{t("termsOfService.k2")}</h1>
      <p className="mb-4 text-text-primary">{t("termsOfService.k3")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k4")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k5")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k6")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k7")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k8")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k9")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k10")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k11")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k12")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k13")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k14")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k15")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k16")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k17")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k18")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k19")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k20")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k21")}</p>

      <h2 className="text-xl font-bold mt-6 mb-3">{t("termsOfService.k22")}</h2>
      <p className="mb-4 text-text-primary">{t("termsOfService.k23")}</p>
      </div>
    </div>
  );
};

export default TermsOfService;